/**
 * URL slugs for blog posts and team members.
 *
 * Slugs are always derived from the English title/name, never the Arabic one —
 * an Arabic slug would percent-encode into unreadable bytes, and the URL needs
 * to stay the same whichever language the visitor is browsing in.
 *
 * There is no slug column in Mongo, so these are recomputed from the record
 * every time. That means renaming a post in the dashboard changes its URL.
 */

const stripDiacritics = (value) =>
  value.normalize("NFKD").replace(/[̀-ͯ]/g, "");

/** "Mr. Ahmed Abdelazim Esmael" -> "ahmed-abdelazim-esmael" */
export const slugify = (value) =>
  stripDiacritics(String(value || ""))
    .toLowerCase()
    .replace(/^(mr|mrs|ms|dr|adv|advocate)\.?\s+/, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

// Fall back to the id so a record with no English title is still reachable.
export const blogSlug = (blog) => slugify(blog?.en?.title) || blog?._id || "";
export const teamSlug = (member) => slugify(member?.en?.name) || member?._id || "";

export const blogPath = (blog) => `/blog/${blogSlug(blog)}`;
export const teamPath = (member) => `/our-team/${teamSlug(member)}`;

/** Match a slug against a list, tolerating an id in place of the slug. */
export const findBySlug = (list, slug, toSlug) =>
  (list || []).find((item) => toSlug(item) === slug || item?._id === slug);
